import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-rodo-information"
}
const _hoisted_2 = { class: "popup-rodo-information__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  type: "a"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  type: "a"
}
const _hoisted_7 = {
  key: 0,
  class: "popup-rodo-information__last-updated"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "popup-rodo-information__close-popup",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paragraphs, (paragraph, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "popup-rodo-information__row"
                }, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.${paragraph.header}`)), 1),
                  (paragraph.type === 'html')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.${paragraph.content}`)
                            
                      }, null, 8, _hoisted_3))
                    : (paragraph.type === 'list')
                      ? (_openBlock(), _createElementBlock("ol", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paragraph.items, (item, i) => {
                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.${item}`)), 1))
                          }), 128))
                        ]))
                      : (paragraph.type === 'mixed')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paragraph.blocks, (block, blockIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: blockIndex }, [
                              (block.type === 'html')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    innerHTML: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.${block.content}`)
                                
                                  }, null, 8, _hoisted_5))
                                : (block.type === 'list')
                                  ? (_openBlock(), _createElementBlock("ol", _hoisted_6, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.items, (item, i) => {
                                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.${item}`)), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.hasLastUpdated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.lastUpdated`)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}